import React from "react";
import { useQuery } from "react-query";

import { bangTinApi } from "src/1/apis/bang_tin.api";

const KPI_CONFIG = [
  {
    key: "phieu_nhap_hang",
    title: "Phiếu nhập hàng",
    iconClass: "!bg-blue-50 !text-blue-600 !border-blue-200",
    numberClass: "!text-blue-600",
    svg: (
      <svg
        className="!w-4 !h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.2"
          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
        />
      </svg>
    ),
  },
  {
    key: "phieu_xuat_hang",
    title: "Phiếu xuất hàng",
    iconClass: "!bg-emerald-50 !text-emerald-600 !border-emerald-200",
    numberClass: "!text-emerald-600",
    svg: (
      <svg
        className="!w-4 !h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.2"
          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
        />
      </svg>
    ),
  },
  {
    key: "de_xuat_nvl",
    title: "Đề xuất nguyên vật liệu",
    iconClass: "!bg-cyan-50 !text-cyan-700 !border-cyan-200",
    numberClass: "!text-cyan-700",
    svg: (
      <svg
        className="!w-4 !h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.2"
          d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
        />
      </svg>
    ),
  },
  {
    key: "de_xuat_hang_hoa",
    title: "Đề xuất hàng hóa",
    iconClass: "!bg-indigo-50 !text-indigo-600 !border-indigo-200",
    numberClass: "!text-indigo-600",
    svg: (
      <svg
        className="!w-4 !h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.2"
          d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
        />
      </svg>
    ),
  },
  {
    key: "de_xuat_combo",
    title: "Đề xuất combo",
    iconClass: "!bg-violet-50 !text-violet-600 !border-violet-200",
    numberClass: "!text-violet-600",
    svg: (
      <svg
        className="!w-4 !h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.2"
          d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 100-6 3 3 0 000 6z"
        />
      </svg>
    ),
  },
  {
    key: "de_xuat_dat_hang",
    title: "Đề xuất đặt hàng",
    iconClass: "!bg-purple-50 !text-purple-600 !border-purple-200",
    numberClass: "!text-purple-600",
    svg: (
      <svg
        className="!w-4 !h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.2"
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        />
      </svg>
    ),
  },
  {
    key: "phieu_huy_hang",
    title: "Phiếu hủy hàng",
    iconClass: "!bg-rose-50 !text-rose-600 !border-rose-200",
    numberClass: "!text-rose-600",
    svg: (
      <svg
        className="!w-4 !h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.2"
          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        />
      </svg>
    ),
  },
  {
    key: "phieu_kiem_kho",
    title: "Phiếu kiểm kho",
    iconClass: "!bg-teal-50 !text-teal-600 !border-teal-200",
    numberClass: "!text-teal-600",
    svg: (
      <svg
        className="!w-4 !h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.2"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
  },
  {
    key: "phieu_kiem_kho_cuoi_thang",
    title: "Phiếu kiểm kho cuối tháng",
    iconClass: "!bg-sky-50 !text-sky-600 !border-sky-200",
    numberClass: "!text-sky-600",
    svg: (
      <svg
        className="!w-4 !h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.2"
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>
    ),
  },
  {
    key: "yeu_cau_dieu_chinh_gia",
    title: "Yêu cầu điều chỉnh giá",
    iconClass: "!bg-amber-50 !text-amber-600 !border-amber-200",
    numberClass: "!text-amber-600",
    svg: (
      <svg
        className="!w-4 !h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.2"
          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
  },
];

export default function KpiCards() {
  const { data: summaryData, isLoading } = useQuery({
    queryKey: ["bang-tin-summary"],
    queryFn: () => bangTinApi.getSummary(),
    select: (res) => res.data?.data,
  });

  const getMetricCount = (key) => {
    if (!summaryData) return 0;
    const value = summaryData[key];
    if (typeof value === "number") return value;
    if (typeof value === "string" && !isNaN(Number(value))) {
      return Number(value);
    }
    return 0;
  };

  return (
    <>
      <h5 className="uppercase font-semibold tracking-wider">
        Tổng hợp phiếu chờ duyệt
      </h5>
      <div className="!grid !grid-cols-2 sm:!grid-cols-2 md:!grid-cols-3 lg:!grid-cols-5 !gap-3">
        {KPI_CONFIG.map((item) => {
          const count = getMetricCount(item.key);
          return (
            <div
              key={item.key}
              className="!bg-white !rounded-xl !p-3.5 sm:!p-4 !shadow-2xs !border !border-slate-200/90 hover:!border-slate-300 hover:!shadow-sm !transition-all !flex !flex-col !justify-between !gap-3"
            >
              {/* Top row: Title and Icon */}
              <div className="!flex !items-start !justify-between !gap-2">
                <span className="!text-sm !font-bold !text-slate-800 !leading-snug !line-clamp-2">
                  {item.title}
                </span>
                <div
                  className={`!w-8 !h-8 !rounded-lg !flex !items-center !justify-center !border !shrink-0 ${item.iconClass}`}
                >
                  {item.svg}
                </div>
              </div>

              {/* Bottom row: Big Count & Unit */}
              <div className="!flex !items-baseline !justify-between !pt-1">
                {isLoading ? (
                  <div className="!h-8 !w-12 !bg-slate-200 !animate-pulse !rounded" />
                ) : (
                  <span
                    className={`!text-3xl !font-black !tracking-tight ${item.numberClass}`}
                  >
                    {count}
                  </span>
                )}
                <span className="!text-sm !font-medium !text-slate-400">
                  phiếu
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
